export { StoreOpeningHoursSpot as default } from './StoreOpeningHours';
